// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.13040"][{"7845":0}[chunkId]] || "1.13041") + "/" + chunkId + ".js";
};